<template>
  	<div id="lookWords">
  		<img src="../../assets/img/index/bg_bendi_home.png" alt="" class="backG">
  		<mt-header fixed title="">
          	<mt-button icon="back" slot="left" @click.native="$router.back()"></mt-button>
        </mt-header>
        <div class="content">
        	<div class="swiper">
	            <p class="wx_fontSize4" style="font-weight: bold;">{{$t('查看助记词')}}</p>
	            <p class="wx_fontSize2">{{$t('您可以导入一下助记词在其他设备上配对，或者用其他设备上的 HMC Wallet Pro 钱包扫描二维码配对。')}}</p>
	            <p class="wx_fontSize2">{{$t('请勿截图！如果有人获取你的助记词将直接获取你的资产！')}}</p>
	        </div>
	        <ul class="table clearfix">
	        	<li v-for="(item,index) in list" class="wx_fontSize3" :key="index">
	        		<mt-badge size="small">{{index+1}}</mt-badge>
	        		{{item}}
	        	</li>
	        </ul>
			    <div class="footer wx_fontSize3" @click="backupTip()">{{$t('查看加密二维码')}}</div>
          <div class="swiper">
            <p class="wx_fontSize2">{{$t('加密二维码是为了方便钱包配对新设备，请不要截屏保存，并且确保周围无其他人或者隐藏摄像头。')}}</p>
          </div>
        </div>
        <div class="box" v-show="isShow">
          <img src="../../assets/img/index/icon_lose.png" alt="" @click.self="backupTip()" class="close">
          <div class="message">
            <img src="../../assets/img/coinDetail/usdt_omni.png" alt="">
            <div class="swiper">
              <p class="wx_fontSize2">{{$t('该二维码仅限 HMC Wallet Pro 钱包使用。扫描时，需在将要导入的APP内输入当前APP的PIN码，方可成功导入对应的助记词。')}}</p>
            </div>
          </div>
        </div>
  	</div>
</template>

<script>

export default {
  	data () {
	    return {
	      list: ['rebal','ober','involve','stock','income','endless','desk','rand','mom','lob','spice','scale'],
        isShow:false,
	    }
  	},
    activated(){
      this.isShow = false;
    },
  	methods: {
	    backupTip(){
	    	this.isShow = !this.isShow;
	    }
  	}
}
</script>

<style scoped>
#lookWords{width:100%;height:100%;}
.mint-header{background: transparent;}
.backG{width:100%;height:100%;}
.mark{width:86%;margin-left:7%;margin-top:50px;height:36%;}
.content{width:100%;height:100%;position: absolute;top:0;padding-top:50px;box-sizing: border-box;
    overflow: scroll;}
.swiper {
  box-sizing: border-box;
  border-radius: 10px;
  color: #fff;
  padding: 10px;
  box-sizing: border-box;
}
.swiper p {
  margin:15px 5px;
}
.table{padding:10px 15px 20px 15px;margin-left:3px;}
.table li{width:calc((100% / 3) - 3px);height:60px;float: left;text-align: center;color:#fff;border:0.5px solid #fff;line-height: 60px;position: relative;}
.footer{width:calc(100% - 30px);height:50px;background:#fff;line-height:50px;text-align: center;color:#1296db;border-radius: 4px;margin-left:15px;position: relative;margin-top: 20px;}
.mint-badge.is-primary{background: transparent;position: absolute;top:-18px;left:5px;}
.box{position: absolute;top:0;left:0;background:rgba(0,0,0,0.9);z-index: 5;width:100%;height:100%;}
.message{width:100%;border-radius: 5px;position: relative;top:22%;}
.message img{width:76%;margin-left:12%;height:80%;}
.close{width:20px;height:20px;position: absolute;top:20px;left:20px;}
</style>